import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import config from '../../../app/config';

export const apiBaseUrl = config.api.openFoodFacts.url;

export const baseQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl,
});
